module.exports = __webpack_public_path__ + "static/slider-2-name-boards-fa8c5fd12f6f9e084ae6853b894c5fa0.png";